@if (header$.visible) {
  <header
    class="fixed z-[999] flex h-20 w-full items-center justify-between bg-skyline-gradient bg-cover bg-center px-4 shadow-lg"
  >
    <a routerLink="/" class="ml-2">
      <img
        src="/assets/images/logos/comcast_business_logo.svg"
        alt="Comcast Business Logo"
        class="h-8 w-auto"
      />
    </a>

    @if (navigation$ | async; as navigation) {
      <nav class="flex justify-end">
        <div class="profile-icon"></div>
        <ul class="flex items-center gap-x-2">
          @if (windowWidth$().underLg) {
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              (menuOpened)="mobileMenuOpen.set(true)"
              (menuClosed)="mobileMenuOpen.set(false)"
              class="!h-8 !w-8 bg-contain bg-center bg-no-repeat transition-all duration-300"
              [ngClass]="{
                'rotate-[0deg] bg-[url(/assets/images/menu-inactive.png)]':
                  !mobileMenuOpen(),
                'rotate-[360deg] bg-[url(/assets/images/menu-active.png)]':
                  mobileMenuOpen(),
              }"
            ></button>
            <mat-menu #menu="matMenu">
              <ul>
                @for (item of navigation; track item.label) {
                  <li
                    (navigationRecordAction)="handleNavAction($event)"
                    [isMobile]="windowWidth$().underLg"
                    [appNavigationRecord]="item"
                  ></li>
                }
              </ul>
            </mat-menu>
          } @else {
            @for (item of navigation; track item.label) {
              <li
                (navigationRecordAction)="handleNavAction($event)"
                [isMobile]="windowWidth$().underLg"
                [appNavigationRecord]="item"
              ></li>
            }
          }
        </ul>
      </nav>
    }
  </header>
}
